import React, { useRef } from 'react';
import { Redirect } from 'react-router-dom';
import { reverse } from 'named-urls';
import routes from '@achievable-me/tundra-wizard/routes';
import ProductLayout from '$components/layout/ProductLayout';
import ScrollToTop from '$components/library/ScrollToTop';
import Seo from '$components/Seo';
import Amc8 from './Amc8';
import Amc12 from './Amc12';
import FinraSie from './FinraSie';
import FinraS6 from './FinraS6';
import FinraS7 from './FinraS7';
import FinraS63 from './FinraS63';
import FinraS65 from './FinraS65';
import FinraS66 from './FinraS66';
import Gre from './GRE';
import UsmleStep1 from './UsmleStep1';
import styles from './styles.scss';
import { useTrack } from '$lib/tracking';

const EXAM_MAP = {
  'amc-8': Amc8,
  'amc-12': Amc12,
  'finra-sie': FinraSie,
  'finra-series-6': FinraS6,
  'finra-series-7': FinraS7,
  'finra-series-63': FinraS63,
  'finra-series-65': FinraS65,
  'finra-series-66': FinraS66,
  gre: Gre,
  'usmle-step-1': UsmleStep1,
};

const Overview = ({ currentUser, slug, product, inflatedContent }) => {
  useTrack('Exam overview | Viewed', { productSlug: slug });
  const Component = EXAM_MAP[slug];
  if (!Component) {
    return <Redirect to={reverse(routes.study.catalog, { productSlug: 'achievable' })} />;
  }

  return (
    <Component
      product={product}
      currentUser={currentUser}
      inflatedContent={inflatedContent}
    />
  );
};

const ProductOverview = (props) => {
  const layoutRef = useRef();

  const { currentUser, location, match } = props;

  return (
    <ProductLayout currentUser={currentUser} location={location} match={match}>
      {({ product, inflatedContent }) => {
        return (
          <>
            <Seo
              title={`${product.name} overview`}
              canonical={reverse(routes.study.overview, { productSlug: product.slug })}
              description={`Overview of the content outline, time requirements, cost, and information on the ${product.name}.`}
            />
            <ScrollToTop elementRef={layoutRef}>
              <div ref={layoutRef} className={styles.layout}>
                <Overview
                  currentUser={currentUser}
                  product={product}
                  slug={product.slug}
                  inflatedContent={inflatedContent}
                />
              </div>
            </ScrollToTop>
          </>
        );
      }}
    </ProductLayout>
  );
};

export default ProductOverview;
